<template>
  <a
    :href="href"
    class="help-link"
    target="_blank"
  >
    <icon-default :icon="icon" size="is-small"></icon-default>
    <span class="ml-50"><slot></slot></span>
  </a>
</template>

<script>
export default {
  name: "AppHelpLink",
  props: {
    pageUri: {
      type: String,
      default: ''
    },
    youtubeLink: {
      type: String,
      default: ''
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    href() {
      if(this.isVideo) {
        return this.youtubeLink
      }

      return '//help.forefrontcrm.com/' + this.pageUri
    },
    icon() {
      if(this.isVideo) {
        return 'play'
      }

      return 'link'
    }
  },
}
</script>

<style lang="scss" scoped>

.help-link {
  display: inline-flex;
  align-items: center;
  margin-left: 0.375rem;
  font-size: 0.875rem;
  font-weight: normal;
  vertical-align: middle;
}
</style>
